import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import FlagIcon from '@mui/icons-material/Flag';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import { useState } from 'react';


export default function FlagIssue({ reportIssueFn, issueId }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const textareaName = `create-issue${issueId}`;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onCreateIssue = (issueId, title) => {
    reportIssueFn(issueId, title);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button sx={{ marginRight: 3 }} onClick={handleClick} endIcon={<FlagIcon />}>Flag an issue</Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: { width: '30%' },
        }}
      >
        <div className="report-issue-dialog">
          <h3>Enter a title for Issue #{issueId} </h3>
          <div style={{ display: "flex", flexDirection: "row", flexShrink: 0, alignContent: "top"}}>
            <TextareaAutosize minRows={2} style={{ flex: 1 }} name={textareaName} id={textareaName} placeholder="Enter a title..."></TextareaAutosize>
            <Button onClick={() => {
              let title = document.getElementsByName(textareaName)[0].value
              onCreateIssue(issueId, title);
            }}>Submit</Button>
          </div>
        </div>
      </Popover>
    </div>
  );
}